<template>
  <div class="h-full flex flex-col justify-center items-center">
    <svg xmlns="http://www.w3.org/2000/svg" class="h-20 w-20 lg:w-28 lg:h-28" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
      <path stroke-linecap="round" stroke-linejoin="round" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
    </svg>
    <p class="mt-3">{{message || __('Nothing found to display')}}</p>
  </div>
</template>
<script setup>
defineProps(['message']);
</script>